import Login from './login/login'
import Register from './register/register'
import GuestInfo from './info'
import { Tabs } from './login-register-tab.styled'
import { useIntl } from 'react-intl'
import { useState } from 'react'
import { string } from 'prop-types'

const LoginRegisterTab = ({ defaultTab, dynamicAreasLogin, dynamicAreasRegister, ...props }) => {
	const [activeTab, setActiveTab] = useState(defaultTab)
	const { formatMessage } = useIntl()

	return (
		<Tabs
			indicatorColor="primary"
			defaultValue={activeTab}
			onChange={(tab) => setActiveTab(tab)}
			items={[
				{
					content: [<Login dynamicAreas={dynamicAreasLogin} key="login" />, <GuestInfo key="guest" />],
					label: formatMessage({ id: 'login_button_tab_label' }),
					name: 'login',
				},
				{
					content: <Register dynamicAreas={dynamicAreasRegister} />,
					label: formatMessage({ id: 'register_button_tab_label' }),
					name: 'register',
				},
			]}
			{...props}
		/>
	)
}

LoginRegisterTab.defaultProps = {
	defaultTab: 'login',
	dynamicAreasLogin: [],
	dynamicAreasRegister: [],
}

LoginRegisterTab.propTypes = {
	defaultTab: string,
}

export default LoginRegisterTab
